import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { LoginService } from './../login/login.service';
import { Usuario } from 'app/domain/usuario';
import { url_form } from 'app/domain/publico';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'menu-app',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    providers: [LoginService]
})

export class MenuComponent {

    title = 'menu';
    user = new Usuario();

    token: any;
    habilitarLlenos: boolean;

    constructor(private loginService: LoginService, private router: Router, private _titulo: Title) {
        this.user.fillFromJSON(window.localStorage.getItem("usuario"));

        this.token = window.localStorage.getItem("key_apm");

        this.habilitarLlenos = false;
    }

    ngOnInit() {
        this._titulo.setTitle("Container Services | Menu");

        this.loginService.validarUsuarioIntegracion(this.user.usuarioCuenta, this.token)
            .then(rsp => {
                /*****Implementacion con Servlets y SpringBoot*****/
                if (rsp.isCorrect) {
                    this.habilitarLlenos = rsp.result.resp;
                }
                else {
                    this.habilitarLlenos = false;
                    console.log('Hubo un error en el envio de datos a la integración');
                }
            });
    }

    Logout() {
        this.loginService.logout();
        this.router.navigate(['/iniciar-sesion']);
    }

    iniciarLlenos() {
        window.open(url_form, "", "width=600,height=600");
        this.loginService.iniciarLlenos(this.user.usuarioCuenta, this.token);
    }
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/view/menu/menu.component.ts